import { ContextManager } from 'dreamstate';

import { AnyObject, Optional } from '@vimeo/core/types/generic';

import { ELiveInteractionQuery, TLiveInteractionUserQueryResponse } from '../../store/queries';
import { IInteractionApplicationUser } from '../../types/interaction_room';

/**
 * Query interaction user in the current manager.
 * Shortcut to access the interaction user object in a sync way.
 *
 * User logged in interaction tools is different from vimeo one.
 * You can be logged as a broadcaster but become a participant from guest page.
 */
export function queryInteractionUserSync(
  manager: ContextManager<AnyObject, AnyObject>,
): Optional<IInteractionApplicationUser> {
  const response: TLiveInteractionUserQueryResponse = manager.queryDataSync({
    type: ELiveInteractionQuery.LIVE_INTERACTION_USER,
  });

  return response?.data;
}
